import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { setLang } from "../lib/i18n";

const AuthContext = createContext(null);

// Arrangørens lagrede språkvalg følger kontoen (settes når de bruker Språkval innlogget)
function applyOrganizerLang(org) {
  if (org && (org.lang === "nb" || org.lang === "nn")) setLang(org.lang);
}

export const AuthProvider = ({ children }) => {
  const [organizer, setOrganizer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("billett_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        setOrganizer(res.data);
        applyOrganizerLang(res.data);
      })
      .catch(() => {
        localStorage.removeItem("billett_token");
        setOrganizer(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, organizerId = null) => {
    const payload = { email, password };
    if (organizerId) payload.organizer_id = organizerId;
    const { data } = await api.post("/auth/login", payload);
    if (data.multiple) {
      return data; // caller must let user pick an organization
    }
    localStorage.setItem("billett_token", data.token);
    setOrganizer(data.organizer);
    applyOrganizerLang(data.organizer);
    return data.organizer;
  };

  const register = async (orgNumber, email, password, fullName = "", phone = "") => {
    const { data } = await api.post("/auth/register", { org_number: orgNumber, email, password, full_name: fullName, phone: phone || null });
    localStorage.setItem("billett_token", data.token);
    setOrganizer(data.organizer);
    return data;
  };

  const registerViaInvite = async (code, name, email, password) => {
    const { data } = await api.post("/auth/register-invite", { code, name, email, password });
    localStorage.setItem("billett_token", data.token);
    setOrganizer(data.organizer);
    return data.organizer;
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setOrganizer(data);
      return data;
    } catch {
      return null;
    }
  };

  const switchOrganization = async (organizerId) => {
    const { data } = await api.post("/auth/switch-organization", { organizer_id: organizerId });
    localStorage.setItem("billett_token", data.token);
    setOrganizer(data.organizer);
    return data.organizer;
  };

  const logout = () => {
    localStorage.removeItem("billett_token");
    setOrganizer(null);
  };

  return (
    <AuthContext.Provider value={{ organizer, loading, login, register, registerViaInvite, refresh, logout, switchOrganization }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
